import React from 'react';
import { DESIGN_STYLES } from '../../utils/estimator';
import { tabBase, tabActive, tabIdle, sectionTitle } from './estimateUi';

export default function StepStyle({ isUA, style, onChange }) {
  return (
    <div className="relative z-[1] py-10 border-b border-border/60">
      <p className={`block ${sectionTitle}`}>{isUA ? 'Стиль' : 'Style'}</p>
      <div className="relative z-[1] flex flex-wrap gap-3 items-start">
        {DESIGN_STYLES.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onChange(s.id)}
            className={`${tabBase} ${style === s.id ? tabActive : tabIdle}`}
          >
            {isUA ? s.labelUA : s.labelEN}
          </button>
        ))}
      </div>
    </div>
  );
}
